import { useAuthStore } from '../../store/useAuthStore'
import styles from '../../styles/admin/SignIn.module.scss'

interface GreetingProps {
  className?: string
  customName?: string
  showUserName?: boolean
}

const Greeting = ({
  className,
  customName,
  showUserName = true,
}: GreetingProps) => {
  const user = useAuthStore((state) => state.user)

  const displayText = showUserName
    ? customName
      ? `Welcome ${customName}`
      : user?.NAME
        ? `Welcome ${user.NAME}`
        : 'Welcome'
    : 'Welcome'

  return (
    <div className={`${styles.greetingWrapper} ${className || ''}`}>
      <h1
        className={
          showUserName ? styles.welcomeTextWrapper : styles.textWrapper
        }
      >
        {displayText}
      </h1>
    </div>
  )
}

export default Greeting